import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  var interactionTypeStyles = {
    color: componentTheme.titleInteractionTypeNamePointsColor,
    fontSize: componentTheme.titleInteractionTypeNamePointsFontSize,
    marginLeft: componentTheme.titleInteractionTypeNamePointsLeftMargin,
    marginRight: componentTheme.titleInteractionTypeNamePointsRightMargin,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
  var optionsButtonDragDropStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'inherit',
    fontSize: componentTheme.optionsButtonDragDropHandleFontSize,
    margin: componentTheme.optionsButtonDragDropHandleMargin
  };
  return {
    quizEntryWrapper: _defineProperty({
      transform: 'translate3d(0, 0, 0)'
    }, mp, {
      breakInside: 'avoid'
    }),
    quizEntryShow: {
      padding: componentTheme.quizEntryShowPadding,
      backgroundColor: componentTheme.quizEntryShowBackgroundColor
    },
    header: {
      height: componentTheme.headerHeight,
      display: 'flex',
      flexWrap: 'nowrap',
      flexDirection: 'row',
      alignItems: 'stretch',
      paddingRight: componentTheme.headerRightPadding
    },
    dndBorder: {
      border: componentTheme.dndBorder
    },
    leftHeader: {
      flex: '8 0 0',
      display: 'inline-flex',
      overflow: 'hidden',
      alignItems: 'center'
    },
    connectingLines: {
      flex: '0 0 auto',
      display: 'inline-flex',
      borderLeft: "".concat(componentTheme.phoneConnectingLinesBorderWidth, " dotted"),
      borderBottom: "".concat(componentTheme.phoneConnectingLinesBorderWidth, " dotted"),
      borderColor: componentTheme.phoneConnectingLinesBorderColor,
      height: '2rem',
      width: '1.2rem',
      marginTop: '-0.8rem',
      marginRight: '1.2rem'
    },
    rightHeader: {
      flex: '0 0 auto',
      display: 'inline-flex',
      textAlign: 'right',
      zIndex: componentTheme.rightHeaderZIndex,
      color: componentTheme.rightHeaderColor,
      button: {
        backgroundColor: 'initial'
      }
    },
    title: interactionTypeStyles,
    interactionTypeName: interactionTypeStyles,
    points: interactionTypeStyles,
    itemHolder: {
      overflowWrap: 'anywhere',
      margin: componentTheme.itemHolderMargin
    },
    optionsButton: _objectSpread(_objectSpread({}, optionsButtonDragDropStyle), {}, {
      cursor: 'pointer'
    }),
    dragAndDropHandle: optionsButtonDragDropStyle
  };
};
export default generateStyle;